/** 24x24 pointer art, aimed from its centre. */
const HOTSPOT = 12;

/** Data-URI CSS cursor from inline SVG art, with a keyword fallback — one builder for every cursor set. */
export function cursor(svg: string, fallback: string): string {
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}") ${HOTSPOT} ${HOTSPOT}, ${fallback}`;
}
